import { render, staticRenderFns } from "./login-dialog-loader.vue?vue&type=template&id=74b9fca8&"
import script from "./login-dialog-loader.vue?vue&type=script&lang=js&"
export * from "./login-dialog-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b9fca8')) {
      api.createRecord('74b9fca8', component.options)
    } else {
      api.reload('74b9fca8', component.options)
    }
    module.hot.accept("./login-dialog-loader.vue?vue&type=template&id=74b9fca8&", function () {
      api.rerender('74b9fca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application-level/login-dialog-loader.vue"
export default component.exports